import { AppTheme } from '@/plugins/vuetify/themes/types';
import { VuetifyThemeVariant } from 'vuetify/types/services/theme';

const variant: VuetifyThemeVariant = {
    primary: '#32bbda',
    secondary: '#b0bec5',
    anchor: '#8c9eff',
    kurs: '#0a8197',
    open: '#8cc63f',
    masterclass: '#000000',
    theory: '#757171',
    party: '#c9c9c9',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
};

const esens: AppTheme = {
    id: 'esens',
    name: 'Esens',
    logo: require('@/assets/s5_logo.png'),
    theme: {
        dark: false,
        disable: false,
        default: false,
        options: {},
        currentTheme: variant,
        themes: {
            dark: variant,
            light: variant,
        },
    },
    visibility: {
        calendar: {
            locations: {
                SingleActivityBig: {
                    ShortId: true,
                },
                SingleActivityNormal: {
                    ShortId: true,
                },
                SingleActivityPopups: {
                    ShortId: true,
                },
                MobileSingleActivityPopups: {
                    ShortId: true,
                },
            },
        },
    },
};

export default esens;
